import { CalculationUtils } from './CalculationUtils';
import { valenzaDenrologica } from './valenzaDenrologica';

export class ClasseDiametricaIntersection implements IClasseDiametrica {
    constructor(payload: server.areaSaggioClasseDiametrica, areaSaggio: server.areaSaggio, specieArborea: domains.domini) {
        this.timeStamp = payload.timeStamp;
        this.id = payload.id;
        this.versioneId = payload.versioneId;
        this.areaSaggioId = payload.areaSaggioId;
        this.specie = payload.specie;
        this.diametro = payload.diametro;
        this.contatore = payload.contatore;
        this.longitude = payload.longitude;
        this.latitude = payload.latitude;
        this.userId = payload.userId;
        this.areaSaggio = areaSaggio;
        this.specieArborea = specieArborea;
        this.specieOrderIndex = payload.specieOrderIndex;
        this.areaClasseDiametrica = this.getAreaClasseDiametrica();
        this.areaInMq = this.getAreaInMq();
        this.areaInHa = this.getAreaInHa();
        this.numeroPianteAdEttaro = this.getNumeroPianteAdEttaro();
        this.altezzaIpsometrica = this.getAltezzaIpsometrica();
        this.areaBasimetricaAdEttaro = this.getAreaBasimetricaAdEttaro();
        this.volumeUnitario = this.getVolumeUnitario();
        this.volumeAdEttaro = this.getVolumeAdEttaro();
        this.diametroMedio = this.getDiametroMedio();
    }

    timeStamp: number;
    id: string;
    versioneId: string;
    areaSaggioId: string;
    specie: number;
    diametro: number;
    contatore: number;
    longitude: number;
    latitude: number;
    userId: string;

    areaSaggio: server.areaSaggio;
    specieArborea: domains.domini;

    areaClasseDiametrica: number;
    areaInMq: number;
    areaInHa: number;
    codiceSpecie: string;
    numeroPianteAdEttaro: number;
    altezzaIpsometrica: number;
    areaBasimetricaAdEttaro: number;
    volumeUnitario: number;
    volumeAdEttaro: number;
    diametroMedio: number;

    specieOrderIndex: number;

    getAreaClasseDiametrica() {
        return CalculationUtils.getAreaClasseDiametrica(this.diametro);
    }

    getAreaInMq(): number {
        return CalculationUtils.getAreaInMq(this.areaSaggio?.area);
    };

    getAreaInHa(): number {
        return CalculationUtils.getAreaInHa(this.areaInMq);
    }

    getNumeroPianteAdEttaro(): number {
        return CalculationUtils.getNumeroPianteAdEttaro(this.contatore, this.areaInHa);
    };

    getAltezzaIpsometrica(): number {
        return CalculationUtils.getAltezzaIpsometrica(this.diametro);
    };

    getAreaBasimetricaAdEttaro(): number {
        return CalculationUtils.getAreaBasimetricaAdEttaro(this.areaClasseDiametrica, this.numeroPianteAdEttaro);
    }

    getVolumeUnitario(): number {
        return CalculationUtils.getVolumeUnitario(this.specieArborea.value, this.diametro, this.altezzaIpsometrica);
    };

    getVolumeAdEttaro(): number {
        return CalculationUtils.getVolumeAdEttaro(this.numeroPianteAdEttaro, this.volumeUnitario);
    };

    getDiametroMedio() :number {
        return CalculationUtils.getDiametroMedio(this.areaBasimetricaAdEttaro, this.numeroPianteAdEttaro);
    };
}